module.exports = __webpack_public_path__ + "static/img/copyright-trading.2a7d3cf0.png";